import { Record } from "immutable";

const defaults = {
    carrierId: undefined,
    carrierCode: undefined,
    serviceCode: undefined,
    name: undefined,
    domestic: undefined,
    international: undefined,
    isMultiPackageSupported: undefined,
};

export class CarrierService extends Record(defaults) {
    declare carrierId: string;
    declare carrierCode: string;
    declare serviceCode: string;
    declare name: string;
    declare domestic: boolean;
    declare international: boolean;
    declare isMultiPackageSupported: boolean;

    constructor(args) {
        super({
            ...args,
            carrierId: args.carrier_id,
            carrierCode: args.carrier_code,
            serviceCode: args.service_code,
            isMultiPackageSupported: args.is_multi_package_supported,
        });
    }
}
